import ConfirmationModal from './Confirmation'
import NetworkText from './NetworkText'
import BudgetEditor from './BudgetEditor'
import Stories from './Stories'
import AccountMarketCredentials from './AccountMarketCredentials'

export default {
  confirmation: ConfirmationModal,
  networkText: NetworkText,
  budgetEditor: BudgetEditor,
  stories: Stories,
  accountMarketCredentials: AccountMarketCredentials,
}
